import { PLATFORM_ENUM } from 'services/api/constants'
import { CampaignState, FollowerState, REQUIREMENT_TYPE_ENUM, RequirementState } from 'state/campaigns'

export const getCampaignFollowerRequirements = (campaign: CampaignState) => {
    if (!campaign) {
        return []
    } else {
        const { requirements } = campaign
        const followerRequirements = requirements.find(
            (requirement: RequirementState) => requirement.type === REQUIREMENT_TYPE_ENUM.FOLLOWER,
        )

        const requirementsPlatform = followerRequirements
            ? followerRequirements?.properties.followers
                ? followerRequirements?.properties.followers.map((require: FollowerState) => require.platform)
                : []
            : []
        return requirementsPlatform
    }
}

export const showDefaultIgPlatform = (platforms: number[], requirementPlatforms: number[]) => {
    // profile platforms except ig
    const socialPlatformList = [PLATFORM_ENUM.FB, PLATFORM_ENUM.TIKTOK, PLATFORM_ENUM.TWITTER]
    // has ig platform / requirement
    const hasIgPlatform = platforms.includes(PLATFORM_ENUM.IG) || requirementPlatforms.includes(PLATFORM_ENUM.IG)
    if (hasIgPlatform) {
        return true
    }

    // check if socialPlatformList exist in platforms
    const hasAnyPlatform = platforms.filter(platform => socialPlatformList.includes(platform))
    // check if socialPlatformList exist in requirement
    const hasAnyPlatformRequirement = requirementPlatforms.filter(requirement =>
        socialPlatformList.includes(requirement),
    )

    // if ig not exist, but the other platform exist, hide ig
    if (!hasIgPlatform && (hasAnyPlatform.length || hasAnyPlatformRequirement.length)) {
        return false
    }

    return true
}
